const companyPerformanceAdapter = (recruiter) => {
  const startDate = recruiter.activeSubscription
    ? recruiter.activeSubscription.startDate
    : recruiter.createdAt;

  return {
    engagements: recruiter.recruiterJobMetrics.totalJobs,
    interviewCount: recruiter.recruiterJobMetrics.interviewsConfirmed,
    interviewRate: recruiter.recruiterJobMetrics.applicationsToInterviewPercent,
    memberSince: startDate,
    placements: recruiter.recruiterJobMetrics.placementsMade,
    testimonial: recruiter.hiringHubTestimonial,
  };
};

export default companyPerformanceAdapter;
